import { ActionContext, ActionTree } from 'vuex'
import { Catalog } from '@one/types'
import { AxiosResponse } from 'axios'
import { RootState } from '../index'
import { BrandsState } from './types'
import { mt } from './mutations'

export const actions: ActionTree<BrandsState, RootState> = {
  fetchBrandsTree({
    commit,
  }: ActionContext<BrandsState, RootState>): Promise<Catalog.BrandTreeRestView> {
      return this.$api.catalog.app
      .getBrandsTree()
      .then(
        ({
          data,
        }: AxiosResponse<Catalog.BrandTreeRestView>) => {
          commit(mt.SET_BRANDS_TREE, data.items)
          return Promise.resolve(data)
        },
      )
  },
  fetchHighlightedBrandsTree(
    { commit }: ActionContext<BrandsState, RootState>,
  ): Promise<Catalog.BrandTreeRestView> {
    return this.$api.catalog.app
      .getBrandsTree({ highlighted: true })
      .then(({ data }: AxiosResponse<Catalog.BrandTreeRestView>) => {
        commit(mt.SET_HIGHLIGHTED_BRANDS_TREE, data.items)
        return Promise.resolve(data)
      })
  },
}
export default actions
